module.exports = __webpack_public_path__ + "e71db1b9548d0a13d21ef572125f87bd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/hamburger.png
// module id = k2Db
// module chunks = 3